/** Import modules */

import { useTranslation }       from "react-i18next";

import { useParams }            from "react-router-dom";

import { useState }             from "react";

/** @import hooks */

// import { qtySum }               from "../../../Hooks/QtySum";

/** Import models */

import Product                  from "../../../Models/SingleTyre";

/** Import components */

import Breadcrumbs              from "../../../Components/Layout/Header/Breadcrumbs";

import ComponentLoader          from "../../../Components/Layout/Loaders/Loader";

import SingleProductLayout      from "../../../Components/Products/Shared/Single/Layout";

import Description              from "../../../Components/Products/Shared/Single/Description";

import SingleProductData        from "../../../Components/Products/Shared/Single/SingleProductData";

import Price                    from "../../../Components/Products/Shared/Single/Price";

// import Stock                    from "../../../Components/Products/Shared/Single/Stock";

import Features                 from "../../../Components/Products/Tyres/Single/Features";

import Properties               from "../../../Components/Products/Shared/Single/Properties";

import Cart                     from "../../../Components/Products/Tyres/Single/Cart";

import Compare                  from "../../../Components/Products/Shared/Single/Compare/Compare";

import Title                    from "../../../Components/Products/Shared/Single/Title";

import Specifications           from "../../../Components/Products/Shared/Single/Specifications";

import ActionNotification       from "../../../Components/Products/Shared/Single/ActionNotifications";

import Delivery                 from "../../../Components/Products/Shared/Single/Delivery";

import SeasonIcons              from "../../../Components/Products/Tyres/Catalog/Item/Season";

import MontageNotification      from "../../../Components/Products/Shared/Single/Montage";

import NoProductsFound           from "../../../Components/Products/Shared/Catalog/NoProductsFound";

import {
    buildCategoryPath,
    extractProductIdFromProvisionalSlug,
    productMatchesCategory
}                                   from "../../../Misc/Permalinks";

import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client";

const VISUAL_MARKUP_QUERY = gql`query {

    visualMarkup {

        markupPercent

    }

}`;

const PRODUCT_TYPE = "tire";
const categoryPath = buildCategoryPath ( PRODUCT_TYPE );


/**
 * 
 * @returns Single tyre page
 * 
 */

const SingleTyre = ( { expectedProductType = PRODUCT_TYPE } ) => {
    
    
    const { loading: visualMarkupLoading, data: visualMarkupData } = useQuery ( VISUAL_MARKUP_QUERY );

    const 
    
    { t }                   = useTranslation    (),

    routeParams             = useParams         (),

    productId               = routeParams.productId || extractProductIdFromProvisionalSlug ( routeParams.slug || routeParams.parameters ),

    { loading, data }       = Product           ( productId ),

    [ 
        
        cartNotification, 
        
        setCartNotification ] = useState ( [] ),

    [ compare, setCompare ] = useState ( [] ),

    [ showMontage, setShowMontage ] = useState ( false ),

    product                 = data?.product?.edges?.[ 0 ]?.node,

    productNotFound         = ! loading && ! visualMarkupLoading && (

        ! productMatchesCategory ( product, PRODUCT_TYPE ) ||

        ! productMatchesCategory ( product, expectedProductType )

    ),

    /** @returns Loaded product data and components */

    LoadProduct = () => {

        if ( loading || visualMarkupLoading ) return <ComponentLoader />

        if ( ! product ) return <NoProductsFound />;

        return <SingleProductLayout data={ product }>

            <SingleProductData data={ { 
            
            image : product.currentImage, 

            studs : product?.studs,
            
            model : `${ product.manufacturer.name.toUpperCase () } ${ product.model }`,
            
            type : product.productType } }>

                <Title product={ product } />

                <Price price={ parseFloat ( product.priceList.retail_price ).toFixed ( 2 ) } visualMarkupData={ visualMarkupData?.visualMarkup } />

                {/* <Stock quantity={ qtySum ( product.productVendors ) } /> */}

                <Delivery product={ product } />

                <SeasonIcons season={ product.season } />

                <Properties product={ product } />

                <Features product={ product } />

                { product.productVendors[ 0 ].qty > 0 &&
                
                <MontageNotification />   
                
                }

                { cartNotification.length > 0 && 

                <ActionNotification data={ cartNotification } /> }

                <Cart product={ product } notifications={ { view: cartNotification, set: setCartNotification } } />

                <Compare 
                
                productId={ product.id } 
                
                type={ product.productType } 
                
                notifications={ { view: compare, set: setCompare } } />

            </SingleProductData>

            <Specifications data={ [

            { name: t ( "manufacturer" ), value: product.manufacturer.name, style: "uppercase" },

            { name: t ( "model" ), value: product.model, style: "regular" },
            
            { name: t ( "vehicle_type" ), value: product.vehicleType, style: "regular" },

            { name: t ( "width" ), value: product.width, style: "regular" },

            { name: t ( "height" ), value: product.height, style: "regular" },

            { name: t ( "diameter" ), value: `R${ parseInt ( product.diameter ) }${ product?.isCTire ? "C" : "" }`, style: "regular" },

            { name: t ( "season" ), value: t ( product.season ), style: "regular" },

            { name: t ( "studs" ), value: product.studs && product.studs !== "no" ? t ( `studs_${ product.studs }` ) : "-", style: "uppercase" },

            { name: "RFT", value: product.runFlat ? t ( "yes" ) : "-", style: "regular" },
            
            { name: t ( "speed_rating" ), value: product.speedRating, style: "uppercase" },

            { name: t ( "load_index" ), value: product.loadIndex, style: "regular" },

            { name: t ( "noise_index" ), value: product.noiseIndex, style: "regular" },

            { name: t ( "fuel_efficiency" ), value: product.fuelEfficiency, style: "uppercase" },

            { name: t ( "wet_breaking" ), value: product.wetBreakingEfficiency, style: "uppercase" },

            { name: t ( "manufacturing_year_dot" ), value: product?.year || "-", style: "uppercase" },

            { name: "OE", value: product.specifications.join ( ", " ) }

            ] } />

            <Description description={ product.description } />

        </SingleProductLayout>

    };

    /** @return component */

    if ( productNotFound ) return ( <div className="container max-content-width">

        <NoProductsFound />

    </div> );

    return ( <div className="container max-content-width">

        { ! loading && product &&

        <Breadcrumbs collection={ [

            { name: t ( "tyres" ), URI: categoryPath },

            { name: product.manufacturer.name.toUpperCase (), URI: `${ categoryPath }/${

                new URLSearchParams ( { f: 12, m: product.manufacturer.name } ).toString ()

            }` },

            { name: `${product.model} - ${product.width} | ${product.height} | R${parseInt(product.diameter)}${product?.isCTire ? "C" : ""} | ${product.loadIndex ? product.loadIndex : ""}${product.speedRating ? ` ${product.speedRating.toUpperCase()}` : ""}`, URI: categoryPath }

        ] } type="basic" /> }

        <LoadProduct />
            
    </div> );

}

/** @export component */
 
export default SingleTyre;